<!------------------------------------------------>
<!--              세금 계산서 컴포넌트            -->
<!------------------------------------------------>
<template>
  <div>
    <!-- 거래처 선택 팝업(소중안) -->
    <clientSelectPopup v-if="clientPopupVisible" :popupVisible="clientPopupVisible" @popupClose="clientPopupClose" />
    <!-- 품목 선택 팝업(소중안) -->
    <billItemSelectPopup
      v-if="billItemPopupVisible"
      :key="componentKey"
      :popupVisible="billItemPopupVisible"
      :clntId="editingData.clntId"
      :taxType="editingData.taxType"
      @popupClose="billItemPopupClose"
    />
    <!-- 종류 / 공급받는 자 구분 -->
    <v-simple-table class="custom-table mt-1">
      <template v-slot:default>
        <tbody>
          <tr>
            <th class="tableTitle required">종류</th>
            <td>
              <div class="d-flex">
                <v-radio-group v-model="editingData.taxTypeIdx" row>
                  <v-radio
                    color="btn_thi"
                    v-for="(item, value) in taxTypeList"
                    :key="value"
                    :label="item.minorNm"
                    :v-model="item.minorCd"
                    @change="taxTypeChanged(item)"
                  ></v-radio>
                </v-radio-group>
              </div>
            </td>
            <th class="tableTitle required" style="width: 120px">공급받는자구분</th>
            <td style="height: auto">
              <div class="d-flex align-center">
                <v-radio-group v-model="editingData.buyBizTpCd" row>
                  <v-radio color="btn_thi" v-for="(item, value) in buyTypeList" :key="value" :label="item.minorNm" :v-model="item.minorCd"></v-radio>
                </v-radio-group>
              </div>
            </td>
          </tr>
          <tr v-if="editingData.taxType === 'CVA'">
            <th class="tableTitle required">상세</th>
            <td>
              <v-radio-group v-model="editingData.amdtTypeIdx" row>
                <v-radio
                  color="btn_thi"
                  v-for="(item, value) in amdtTypeList"
                  :key="value"
                  :label="item.minorNm"
                  :v-model="item.minorCd"
                  @change="amdtTypeChanged(item)"
                ></v-radio>
              </v-radio-group>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="d-flex justify-space-between align-center mt-10 mb-2">
      <p class="font-weight-bold mb-0 error--text">{{ '이메일을 입력하면 해당 메일주소로 전자(세금)계산서가 발송됨' }}</p>
      <v-btn v-if="seq > 0" color="primary" elevation="0" small outlined @click="openNewTab">세금계산서 미리보기</v-btn>
    </div>
    <div class="d-flex justify-space-between align-center mt-2 mb-4" :key="errorKey">
      <p v-if="editingData.errMsg" class="font-weight-bold mb-0 error--text">세금계산서 발행 에러 메시지 : {{ editingData.errMsgNm }}</p>
    </div>
    <!--입력 테이블 1(공급자)-->
    <section class="d-lg-flex d-md-block">
      <div class="mt-5">
        <div class="d-flex justify-space-between align-center mb-2">
          <p class="mb-3 font-weight-bold">공급자</p>
          <!-- <div class="d-flex mb-3">
            <v-btn color="primary" elevation="0" small outlined @click="btnSupMng">다음에도 사용하기</v-btn>
          </div>-->
        </div>
        <v-form ref="supForm">
          <v-simple-table class="custom-table">
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="tableTitle required">등록 번호</th>
                  <td>
                    <v-text-field v-model="editingData.supRegnum" readonly :rules="[rules.required]" solo hide-details="auto" spellcheck="false" />
                  </td>
                  <th class="tableTitle">종사업장 번호</th>
                  <td>
                    <v-text-field v-model="editingData.supSoId" readonly solo hide-details="auto" spellcheck="false" />
                  </td>
                </tr>
                <tr>
                  <th class="tableTitle required">상호</th>
                  <td>
                    <v-text-field v-model="editingData.supCompany" readonly :rules="[rules.required]" solo hide-details="auto" spellcheck="false" />
                  </td>
                  <th class="tableTitle required">성명</th>
                  <td>
                    <v-text-field v-model="editingData.supEmployer" readonly :rules="[rules.required]" solo hide-details="auto" spellcheck="false" />
                  </td>
                </tr>
                <tr>
                  <th class="tableTitle">사업장</th>
                  <td colspan="3">
                    <div class="d-flex align-center">
                      <v-text-field v-model="editingData.supAddress" readonly solo hide-details="auto" spellcheck="false" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="tableTitle">업태</th>
                  <td>
                    <v-text-field v-model="editingData.supBizcond" readonly solo hide-details="auto" spellcheck="false" />
                  </td>
                  <th class="tableTitle">종목</th>
                  <td>
                    <v-text-field v-model="editingData.supBizitem" readonly solo hide-details="auto" spellcheck="false" />
                  </td>
                </tr>
                <tr>
                  <th class="tableTitle required">이메일</th>
                  <td colspan="3">
                    <div class="d-flex align-center">
                      <v-text-field
                        v-model="editingData.supEmpemail"
                        :rules="[rules.required]"
                        readonly
                        solo
                        hide-details="auto"
                        spellcheck="false"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
      </div>
      <v-divider vertical class="mx-3 mt-8 d-lg-inline d-md-none"></v-divider>
      <div class="mt-5">
        <div class="d-flex justify-space-between align-center">
          <p class="mb-3 font-weight-bold">공급받는자</p>
          <div class="d-flex mb-3">
            <v-btn color="primary" elevation="0" small outlined @click="btnClientMng">거래처 관리</v-btn>
          </div>
        </div>
        <v-form ref="buyForm">
          <v-simple-table class="custom-table" :key="componentKey">
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="tableTitle required">
                    등록번호
                    <v-tooltip top color="primary" max-width="300px">
                      <template v-slot:activator="{ on }">
                        <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                      </template>
                      <div class="tooltip-text">{{ 'ex)000-00-00000' }}</div>
                    </v-tooltip>
                  </th>
                  <td>
                    <v-text-field
                      v-model="editingData.buyRegnum"
                      :rules="[rules.required, rules.regNumFormat]"
                      solo
                      hide-details="auto"
                      class="editor_bg"
                      @change="buyRegnumChanged(editingData.buyRegnum)"
                    />
                  </td>
                  <th class="tableTitle">종사업장번호</th>
                  <td>
                    <v-text-field v-model="editingData.buySoId" solo hide-details="auto" class="editor_bg" />
                  </td>
                </tr>
                <tr>
                  <th class="tableTitle required">상호</th>
                  <td>
                    <v-text-field v-model="editingData.buyCompany" :rules="[rules.required]" solo hide-details="auto" class="editor_bg" />
                  </td>
                  <th class="tableTitle required">성명</th>
                  <td>
                    <v-text-field v-model="editingData.buyEmployer" :rules="[rules.required]" solo hide-details="auto" class="editor_bg" />
                  </td>
                </tr>
                <tr>
                  <th class="tableTitle">사업장</th>
                  <td colspan="3">
                    <div class="d-flex align-center">
                      <v-text-field v-model="editingData.buyAddress" solo hide-details="auto" class="editor_bg" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="tableTitle">업태</th>
                  <td>
                    <v-text-field v-model="editingData.buyBizcond" solo hide-details="auto" class="editor_bg" />
                  </td>
                  <th class="tableTitle">종목</th>
                  <td>
                    <v-text-field v-model="editingData.buyBizitem" solo hide-details="auto" class="editor_bg" />
                  </td>
                </tr>
                <tr>
                  <th class="tableTitle required">이메일</th>
                  <td colspan="3">
                    <div class="d-flex align-center">
                      <v-text-field
                        v-model="editingData.buyEmpemail"
                        :rules="[rules.required]"
                        solo
                        hide-details="auto"
                        spellcheck="false"
                        class="editor_bg"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
      </div>
    </section>
    <!-- 작성일자 -->
    <v-form ref="etcForm">
      <v-simple-table class="custom-table mt-8">
        <template v-slot:default>
          <tbody>
            <tr>
              <th class="tableTitle text-center required">작성일자</th>
              <td>
                <div class="d-lg-flex d-md-block align-center">
                  <v-menu
                    ref="genTm"
                    v-model="genTmOpend"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="unset"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :rules="[rules.required]"
                        :value="formatDate(editingData.genTm, '.')"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        solo
                        class="editor_bg"
                        hide-details="auto"
                        spellcheck="false"
                        aria-readonly=""
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="editingData.genTm" @input="genTmChanged" no-title scrollable></v-date-picker>
                  </v-menu>

                  <!-- <i-date-time-picker
                    ref="idateTimePicker"
                    :firstDisplayDate="editingData.genTm"
                    class="editor_bg"
                    solo
                    :dateOnly="true"
                    :menu="true"
                    @getDate="setGenTm($event)"
                  ></i-date-time-picker>-->
                  <p class="error--text ma-0 ml-lg-4 ml-md-0">{{ '※작성일자는 공급 연월일을 의미함' }}</p>
                </div>
              </td>
              <th class="tableTitle text-center">비고</th>
              <td colspan="3">
                <v-text-field v-model="editingData.taxBigo" solo hide-details="auto" class="editor_bg" />
              </td>
            </tr>
            <tr>
              <th class="tableTitle text-center">합계금액</th>
              <td>
                <v-text-field
                  :value="formatToKoreanWon(editingData.payTotalprice)"
                  solo
                  hide-details="auto"
                  suffix="원"
                  class="text-right"
                  @input="inputFormatToKoreanWon($event, 'payTotalprice')"
                />
              </td>
              <th class="tableTitle text-center">공급가액</th>
              <td>
                <v-text-field
                  :value="formatToKoreanWon(editingData.taxSupprice)"
                  solo
                  hide-details="auto"
                  suffix="원"
                  class="text-right"
                  @input="inputFormatToKoreanWon($event, 'taxSupprice')"
                />
              </td>
              <th class="tableTitle text-center">세액</th>
              <td>
                <v-text-field
                  :value="formatToKoreanWon(editingData.taxTaxprice)"
                  solo
                  hide-details="auto"
                  suffix="원"
                  class="text-right"
                  @input="inputFormatToKoreanWon($event, 'taxTaxprice')"
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-form>

    <!-- 품목 -->
    <!-- 안내 문구-->
    <!-- <p
      class="primary--text mt-10"
    >{{ `품목의 월은 작성일자의 월이 표시되고 변경은 작성일자 수정시 자동 반영됨, 합계의 '계산' 버튼은 금액을 공급가액과 세액으로 계산할 수 있음` }}</p>-->
    <!--추가 삭제 버튼-->
    <div class="d-flex justify-space-between mt-5" :key="`item_btn_${componentKey}`">
      <div class="d-flex" style="gap: 8px">
        <v-btn color="primary" elevation="0" small outlined :disabled="editingData.genTm && editingData.buyRegnum ? false : true" @click="btnItemAdd"
          >품목추가</v-btn
        >
      </div>
    </div>
    <!-- 품목 목록 -->
    <v-form ref="itemForm">
      <v-simple-table class="custom-table item-table mt-3 w-full" :key="`item_list_${componentKey}`">
        <template v-slot:default>
          <tbody>
            <tr>
              <th class="tableTitle text-center">월</th>
              <th class="tableTitle text-center">일</th>
              <th class="tableTitle text-center" style="min-width: 200px">품목</th>
              <th class="tableTitle text-center" style="min-width: 200px">요금제명</th>
              <!-- <th class="tableTitle text-center">규격</th> -->
              <th class="tableTitle text-center">수량</th>
              <th class="tableTitle text-center" style="min-width: 120px">단가</th>
              <!-- <th class="tableTitle text-center">합계</th> -->
              <th class="tableTitle text-center" style="min-width: 120px">공급가액</th>
              <th class="tableTitle text-center" style="min-width: 120px">세액</th>
              <th class="tableTitle text-center" style="min-width: 120px">비고</th>
              <th class="tableTitle"></th>
            </tr>
            <tr v-for="(item, index) in editingData.itemList" :key="index">
              <td>
                <!-- 월 -->
                <v-text-field
                  v-model="item.month"
                  class="editor_bg"
                  solo
                  hide-details="auto"
                  maxlength="2"
                  @input="formatToDate($event, item, 'month')"
                  @change="dateValueChanged($event, item, 'month')"
                />
              </td>
              <td>
                <!-- 일 -->
                <v-text-field
                  v-model="item.day"
                  class="editor_bg"
                  solo
                  hide-details="auto"
                  maxlength="2"
                  @input="formatToDate($event, item, 'day')"
                  @change="dateValueChanged($event, item, 'day')"
                />
              </td>
              <td>
                <!-- 품목 -->
                <div class="d-flex align-center">
                  <v-text-field v-model="item.itemName" solo hide-details="auto" readonly />
                  <!-- <v-btn color="primary" elevation="0" small class="ml-4">조회</v-btn> -->
                </div>
              </td>
              <td>
                <!-- 요금제명 -->
                <div class="d-flex align-center">
                  <v-text-field v-model="item.feeName" solo hide-details="auto" readonly />
                  <!-- <v-btn color="primary" elevation="0" small class="ml-4">조회</v-btn> -->
                </div>
              </td>
              <!-- 규격 -->
              <!-- <td>
                <v-text-field v-model="item.itemUnit" solo hide-details="auto" />
              </td>-->
              <td>
                <!--수량 -->
                <!-- <v-text-field v-model="item.itemNum" solo hide-details="auto" readonly /> -->
              </td>
              <td>
                <!-- 단가-->
                <!-- <v-text-field :value="formatToKoreanWon(item.itemDanga)" solo hide-details="auto" suffix="원" readonly /> -->
              </td>
              <!-- 합계 -->
              <!-- <td class="text-center">
                <v-btn color="primary" elevation="0" small @click="calcPopupVisible = true">계산</v-btn>
              </td>-->
              <td>
                <!-- 공급가액 -->
                <v-text-field
                  :value="formatToKoreanWon(item.taxSupprice)"
                  solo
                  hide-details="auto"
                  suffix="원"
                  class="text-right"
                  @input="inputFormatToKoreanWonItem($event, index, 'taxSupprice')"
                />
              </td>
              <td>
                <!-- 세액 -->
                <v-text-field
                  :value="formatToKoreanWon(item.taxTaxprice)"
                  solo
                  hide-details="auto"
                  suffix="원"
                  class="text-right"
                  @input="inputFormatToKoreanWonItem($event, index, 'taxTaxprice')"
                />
              </td>
              <td>
                <!-- 비고 -->
                <v-text-field v-model="item.itemBigo" readonly solo hide-details="auto" class="editor_bg" />
              </td>
              <td class="text-center">
                <!-- 삭제 -->
                <v-btn color="primary" elevation="0" small @click="btnItemRemove(index)">삭제</v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-form>
    <!-- 청구 -->
    <v-form ref="billForm">
      <v-simple-table class="custom-table mt-5">
        <template v-slot:default>
          <tbody>
            <tr>
              <th class="tableTitle text-center">현금</th>
              <th class="tableTitle text-center">수표</th>
              <th class="tableTitle text-center">어음</th>
              <th class="tableTitle text-center">외상미수금</th>
            </tr>
            <tr>
              <td>
                <v-text-field
                  :value="formatToKoreanWon(editingData.cashPayAmt)"
                  solo
                  hide-details="auto"
                  :rules="[rules.numCheck]"
                  suffix="원"
                  class="editor_bg text-right"
                  @input="inputFormatToKoreanWon($event, 'cashPayAmt')"
                />
              </td>
              <td>
                <v-text-field
                  :value="formatToKoreanWon(editingData.checkPayAmt)"
                  solo
                  hide-details="auto"
                  :rules="[rules.numCheck]"
                  suffix="원"
                  class="editor_bg text-right"
                  @input="inputFormatToKoreanWon($event, 'checkPayAmt')"
                />
              </td>
              <td>
                <v-text-field
                  :value="formatToKoreanWon(editingData.billPayAmt)"
                  solo
                  hide-details="auto"
                  :rules="[rules.numCheck]"
                  suffix="원"
                  class="editor_bg text-right"
                  @input="inputFormatToKoreanWon($event, 'billPayAmt')"
                />
              </td>
              <td>
                <v-text-field
                  :value="formatToKoreanWon(editingData.tickPayAmt)"
                  solo
                  hide-details="auto"
                  :rules="[rules.numCheck]"
                  suffix="원"
                  class="editor_bg text-right"
                  @input="inputFormatToKoreanWon($event, 'tickPayAmt')"
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-form>
    <v-card class="d-flex align-center mt-6 py-3 px-6" flat color="main_bg" rounded="0">
      <p class="ma-0">이 금액을</p>
      <v-radio-group v-model="editingData.billTypeIdx" row class="mx-3">
        <v-radio
          color="btn_thi"
          v-for="(item, value) in billTypeList"
          :key="value"
          :label="item.minorNm"
          :v-model="item.minorCd"
          @change="billTypeChanged(item)"
        ></v-radio>
      </v-radio-group>
      <p class="ma-0">합니다.</p>
    </v-card>
  </div>
</template>

<script>
// 컴포넌트
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import iDxPopup from '@/components/common/iDxPopup.vue'
import baseview from '@/views/base/baseview.vue'
import clientSelectPopup from '@/components/esgCommon/clientSelectPopup.vue'
import billItemSelectPopup from '@/components/esgCommon/billItemSelectPopup.vue'
// api
import {
  getTaxInvoiceManage, //세금계산서 조회
  IssuanceTaxInvoice, // 세금계산서 보류 및 발행
} from '@/payment/api/taxInvoice.js'
// utils
import { getUserCd } from '@/utils/token'
import { getCommonCode } from '@/api/common/commonApi'
//
export default {
  mixins: [baseview],
  components: { IDateTimePicker, clientSelectPopup, billItemSelectPopup },
  name: 'taxInvoice',
  props: {
    seq: {
      type: Number,
      default: () => null,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      componentKey: 0,
      errorKey: 0,
      initalData: {
        taxTypeIdx: 0, // 종류
        amdtTypeIdx: 0, // 상세 구분
        buyBizTpCd: 0, // 공급받는자 구분
        billTypeIdx: 0, // 청규 영수 구분
        supRegnum: '185-88-01405',
        supSoId: '',
        supCompany: '주식회사 한국전기공사협회 안전기술원',
        supEmployer: '조상욱',
        supAddress: '충북 청주시 흥덕구 오송읍 오송생명8로 9',
        supBizcond: '서비스업,도매 및 소매업',
        supBizitem: '재해예방기술지도,안전진단',
        supEmpemail: 'system@kiest.co.kr',
        genTm: '', // 작성일자
        taxBigo: '', // 비고
        payTotalprice: '', // 합계금액
        taxSupprice: '', // 공급가액
        taxTaxprice: '', // 세액
        cashPayAmt: '', //현금 결제금액
        checkPayAmt: '', // 수표 결제금액
        billPayAmt: '', // 어음 결제금액
        tickPayAmt: '', // 외상 결제금액
        itemList: [],
        status: '',
        currBuyRegNum: '', //공급받는자 등록번호
      }, // 기본정보
      genTmOpend: false,
      taxTypeList: [
        { minorCd: 'VAT', minorNm: '세금계산서' },
        { minorCd: 'CVA', minorNm: '수정세금계산서' },
      ],
      amdtTypeList: [
        { minorCd: 'A01', minorNm: '기재사항의 착오 정정' },
        { minorCd: 'A02', minorNm: '공급가액변동' },
        { minorCd: 'A03', minorNm: '계약의 해제' },
        { minorCd: 'A04', minorNm: '내국신용장 사후 개설' },
        { minorCd: 'A05', minorNm: '착오에 의한 이중발행' },
      ],
      billTypeList: [
        { minorCd: 'T02', minorNm: '청구' },
        { minorCd: 'T01', minorNm: '영수' },
      ],
      buyTypeList: [{ minorCd: '00001', minorNm: '사업자등록번호' }],
      systemErrList: [],
      editingData: {}, // 저장정보
      numFormat: /^-?\d{1,3}(,\d{3})*(\.\d+)?$/,
      regNumFormat: /^\d{3}-\d{2}-\d{5}$/,
      rules: {
        required: (value) => !!value || '필수입력 값입니다.',
        numCheck: (value) =>
          !(value != null && value != '' && value.toString().match(this.numFormat) == null) || this.$t('올바르지 않은 형식입니다.'),
        regNumFormat: (value) =>
          !(value != null && value != '' && value.toString().match(this.regNumFormat) == null) || this.$t('올바르지 않은 형식입니다.'),
      },
      clientPopupVisible: false, // 거래처 관리 팝업
      billItemPopupVisible: false, // 품목팝업
    }
  },
  watch: {
    seq: {
      deep: true,
      handler() {
        if (this.seq) {
          this.btnSearch(this.seq)
        } else {
          this.editingData = Object.assign({}, this.initalData) // 상세보기 시 데이터 세팅
        }
      },
    },
  },
  activated() {
    this.currBuyRegNum = this.$route.params?.data?.buyRegnum
    if (this.$route.params.data) {
      if (this.$route.params.data.__created__) {
        this.editingData = Object.assign({}, this.initalData)
      }
    } else if (this.$route.params.issueParam) {
      // 미발행 메뉴에서 넘어왔을 때
      this.editingData = { ...this.initalData, ...this.$route.params.issueParam }
    }
  },
  created() {},
  mounted() {},
  methods: {
    formatDate(date, div = '.') {
      if (date) {
        date = date.replaceAll('-', '').replace('.', '')
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}${div}${month}${div}${day}`
      }
      return ''
    },
    setGenTm(e, type) {
      // 날짜 컴포넌트 데이터 변경
      if (e) {
        this.editingData.genTm = e.replaceAll('-', '')
        this.componentKey++
      }
    },
    dateValueChanged(value, item, field) {
      // date 유효한 형식으로 변환
      if (value !== '' && this.editingData.genTm) {
        if (value.length == 1 && value !== '0') {
          item[field] = `0${value}`
        } else if (value === '0' || value === '00') {
          this.vSnackbar(this.$t('유효하지 않은 날짜입니다. 날짜를 확인해주세요.'), 'warn', 3000)
          item[field] = ''
          return
        }
      }
    },
    formatToDate(value, item, field) {
      // 품목 날짜 형식 validation
      if (value !== '' && this.editingData.genTm) {
        if (value[0] == '0' || (parseInt(value) > 0 && parseInt(value) < 13)) return
        const yy = this.editingData.genTm.substring(0, 4)
        const mm = item.month
        const dd = item.day
        const date = new Date(`${yy}-${mm}-${dd}`)
        if (isNaN(date.getTime())) {
          this.vSnackbar(this.$t('유효하지 않은 날짜입니다. 날짜를 확인해주세요.'), 'warn', 3000)
          item[field] = ''
          return
        }
      }
    },

    formatToKoreanWon(value) {
      // 문자열을 숫자로 파싱하여 한국 원 단위로 포맷팅
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      }
      return 0
    },
    inputFormatToKoreanWon(value, item = null, field = null) {
      // 문자열을 숫자로 파싱하여 한국 원 단위로 포맷팅
      if (typeof value === 'string') {
        this.editingData[item] = value.replaceAll(',', '')
      }
      // const numberValue = parseFloat(value.toString().replace(/,/g, ''))
      // if (!isNaN(numberValue) && field == null) {
      //   this.editingData[item] = numberValue.toLocaleString('ko-KR')
      // }
    },
    inputFormatToKoreanWonItem(value, index, field) {
      this.editingData.itemList[index][field] = value.replaceAll(',', '')
    },
    /**********************************************************/
    /***********************버튼 이벤트 ************************/
    /**********************************************************/
    btnSearch(seq) {
      this.openLoading()
      getCommonCode('TAX002')
        .then((res) => {
          if (res.success) {
            this.systemErrList = res.list
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          let errorMsgCd = null
          getTaxInvoiceManage({ seq: seq }, true)
            .then((res) => {
              console.log('@@@ res', res)
              this.editingData = res.list[0]
              // this.editingData.buyRegnum = this.currBuyRegNum
              this.editingData.genTm = this.formatDate(res.list[0].genTm, '-')
              this.itemList = this.editingData.itemList

              // 먼저 에러 메시지 코드를 찾고 저장
              // console.log('@@@@ res.list[0].errMsg', res.list[0].errMsg)
              // console.log('@@@@ res.list[0].errMsg', res.list[0].errMsg != null, this.systemErrList.length)
              if (res.list[0].errMsg != null) {
                errorMsgCd = this.systemErrList.find((el) => {
                  // console.log('#1 ==> ', el.minorCd, ' == ', this.editingData.errMsg, el.minorCd == this.editingData.errMsg)
                  if (el.minorCd == this.editingData.errMsg) return true
                })
              }

              this.editingData.taxTypeIdx = this.taxTypeList.findIndex((el) => el.minorCd === res.list[0].taxType)
              this.editingData.amdtTypeIdx = this.amdtTypeList.findIndex((el) => el.minorCd === res.list[0].amdtType)
              this.editingData.billTypeIdx = this.billTypeList.findIndex((el) => el.minorCd === res.list[0].billType)
              this.editingData.buyBizTpCd = 0

              // errMsg 코드값에 따라 시스템코드 저장된 메시지 값 표현 (시스템코드에 동일한 코드 없을시 null)
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.editingData.errMsgNm = errorMsgCd ? errorMsgCd.minorNm : '알 수 없음'
              this.errorKey++
              this.endLoading()
            })
        })
    },
    genTmChanged(e) {
      this.genTmOpend = false
      // 비고란에 기본으로 안전기술원 계좌번호 데이터를 넣음
      if (!this.editingData.taxBigo) {
        getCommonCode('CT001')
          .then((res) => {
            if (res.success) {
              const accountInfo = res.list.find((el) => el.minorCd === '00005')
              if (accountInfo) {
                this.editingData.taxBigo = accountInfo.remark
              }
              this.endLoading()
            }
          })
          .catch(() => {
            this.endLoading()
          })
      }
    },
    btnItemAdd() {
      // 품목 추가
      if (!this.editingData.clntId) {
        this.vToastify(this.$t('거래처를 먼저 선택하세요.'), 'info')
        return
      }
      this.billItemPopupVisible = true
    },
    btnItemRemove(index = null) {
      // 품복 삭제
      if (typeof index == 'number') {
        // 항목 개별 삭제
        if (this.editingData.itemList.length == 1) this.editingData.itemList = []
        else this.editingData.itemList.splice(index, 1)
        if (this.editingData.itemList.length > 0) {
          let taxSupprice = 0
          let taxTaxprice = 0
          this.editingData.itemList.forEach((el) => {
            taxSupprice += parseInt(el.taxSupprice.replaceAll(',', ''))
            taxTaxprice += parseInt(el.taxTaxprice.replaceAll(',', ''))
          })
          this.editingData.taxSupprice = taxSupprice
          this.editingData.taxTaxprice = taxTaxprice
          this.editingData.payTotalprice = taxSupprice + taxTaxprice
        }
        return
      }
    },

    /**********************************************************/
    /***********************버튼 이벤트 ************************/
    /**********************************************************/
    btnPending() {
      // 보류하기
      console.log('@@@ this.editingData', this.editingData)
      let errorMsg = ''
      if (!this.$refs.buyForm.validate()) {
        errorMsg = '공급받는자 정보를 입력하세요.'
      }
      if (errorMsg !== '') {
        this.vToastify(this.$t(errorMsg), 'info')
        return
      }
      this.vToastifyPrompt(
        this.$t('세금계산서 발급을 보류하시겠습니까?'),
        'info',
        (current) => {
          //
          this.editingData.taxType = this.taxTypeList[this.editingData.taxTypeIdx].minorCd
          this.editingData.amdtType = this.editingData.amdtTypeIdx >= 0 ? this.amdtTypeList[this.editingData.amdtTypeIdx].minorCd : null
          this.editingData.billType = this.billTypeList[this.editingData.billTypeIdx].minorCd
          this.editingData.sendType = 'PND'
          this.editingData.itemList.forEach((item) => {
            item.taxGendate = `${this.editingData.genTm.substring(0, 4)}${item.month}${item.day}`
          })
          this.openLoading()
          IssuanceTaxInvoice(this.editingData, true)
            .then((res) => {
              //
              console.log('@@res', res.map.seq)
              this.btnSearch(res.map.seq)
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnIssue() {
      // 발급하기
      console.log('@@ 발급하기', this.editingData)
      let errorMsg = ''
      if (!this.$refs.buyForm.validate()) {
        errorMsg = '공급받는자 정보를 입력하세요.'
      } else if (!this.editingData.genTm) {
        errorMsg = '작성일자를 입력하세요.'
      } else if (this.editingData.itemList.length < 1) {
        errorMsg = '품목 정보를 입력하세요.'
      } else if (
        this.editingData.cashPayAmt == '' &&
        this.editingData.checkPayAmt == '' &&
        this.editingData.billPayAmt == '' &&
        this.editingData.tickPayAmt == ''
      ) {
        errorMsg = `${this.billTypeList[this.editingData.billTypeIdx].minorNm}금액 정보를 입력하세요.`
      } else if (this.editingData.taxType == 'CVA' && this.editingData.amdtTypeIdx == null) {
        errorMsg = '상세를 선택하세요.'
      }

      if (this.editingData.taxType != 'CVA') {
        this.editingData.amdtTypeIdx = null
      }

      if (this.regNumFormat.test(this.editingData.buyRegnum) == false) {
        errorMsg = '올바르지 않은 사업자 등록번호 형식입니다.'
      }

      if (errorMsg !== '') {
        this.vToastify(this.$t(errorMsg), 'info')
        return
      }
      this.vToastifyPrompt(
        this.$t('세금계산서 발급을 진행하시겠습니까?'),
        'info',
        (current) => {
          console.log(this.editingData)
          this.editingData.itemList.forEach((item) => {
            item.taxGendate = `${this.editingData.genTm.substring(0, 4)}${item.month}${item.day}`
          })
          this.editingData.taxType = this.taxTypeList[this.editingData.taxTypeIdx].minorCd
          this.editingData.amdtType = this.editingData.amdtTypeIdx != null ? this.amdtTypeList[this.editingData.amdtTypeIdx].minorCd : null
          this.editingData.billType = this.billTypeList[this.editingData.billTypeIdx].minorCd
          this.editingData.sendType = 'SND'
          console.log('##### this.editingData', JSON.stringify(this.editingData))
          this.openLoading()
          IssuanceTaxInvoice(this.editingData, true)
            .then((res) => {
              //
              console.log('@@res', res.map.seq)
              this.btnSearch(res.map.seq)
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnReset() {
      // 초기화
      this.vToastifyPrompt(
        this.$t('작성한 데이터를 초기화하시겠습니까?'),
        'info',
        (current) => {
          this.editingData = Object.assign(this.initalData)
          console.log('@@ this.editingData', this.editingData)
          this.editingData.itemList = [] // 품목 리스트
          this.editingData.genTm = ''
          this.$refs.idateTimePicker.onCleared()
          this.componentKey++
        },
        null,
        true
      )
    },
    taxTypeChanged(item) {
      // 종류 변경
      console.log('############ this.editingData.itemList', this.editingData.itemList)
      console.log('############ this.editingData.itemList', this.editingData)
      this.editingData.taxType = item.minorCd
      // this.editingData.itemList = []
      if (!this.editingData.amdtType) this.editingData.amdtType = this.amdtTypeList[0].minorCd
      this.changeNegative() // 금액 음수화
    },
    changeNegative() {
      this.editingData.payTotalprice *= -1
      this.editingData.taxSupprice *= -1
      this.editingData.taxTaxprice *= -1

      this.editingData.itemList.forEach((item) => {
        item.taxSupprice *= -1
        item.taxTaxprice *= -1
      })

      this.editingData.cashPayAmt *= -1
      this.editingData.checkPayAmt *= -1
      this.editingData.billPayAmt *= -1
      this.editingData.tickPayAmt *= -1
      if (this.editingData.taxType === 'CVA') {
        this.editingData.billType = 'T01'
        this.editingData.billTypeIdx = 1
      } else if (this.editingData.taxType === 'VAT') {
        this.editingData.billType = 'T02'
        this.editingData.billTypeIdx = 0
      }
    },
    amdtTypeChanged(item) {
      // 종류 변경
      this.editingData.amdtType = item.minorCd
    },
    billTypeChanged(item) {
      // 종류 변경
      this.editingData.billType = item.minorCd
    },
    //공급받는자의 등록번호 데이터 변경 이벤트
    buyRegnumChanged(item) {
      this.editingData.buyRegnum = item
      this.currBuyRegNum = item
    },
    btnClientMng() {
      this.clientPopupVisible = true
    },
    clientPopupClose(clntData) {
      // 거래처 선택
      console.log('@@ clnt', clntData)
      this.clientPopupVisible = false
      if (Object.keys(clntData).length > 0) {
        this.editingData.clntId = clntData.clntId
        this.editingData.buyRegnum = clntData.rgstNo
        this.editingData.buyCompany = clntData.clntNm
        this.editingData.buyEmployer = clntData.rpstNm
        this.editingData.buyAddress = `${clntData.addrs1}${clntData.addrs2 ? ', ' + clntData.addrs2 : ''}`
        this.editingData.buyBizcond = clntData.detailNm
        this.editingData.buyEmpemail = clntData.email
      }
      this.componentKey++
    },
    billItemPopupClose(itemList) {
      // 품목 추가
      this.billItemPopupVisible = false
      if (itemList.length > 0) {
        this.editingData.itemList = itemList
        let taxSupprice = 0
        let taxTaxprice = 0
        itemList.forEach((el) => {
          taxSupprice += parseInt(el.taxSupprice)
          taxTaxprice += parseInt(el.taxTaxprice)
        })
        this.editingData.taxSupprice = taxSupprice
        this.editingData.taxTaxprice = taxTaxprice
        this.editingData.payTotalprice = taxSupprice + taxTaxprice
      }
      this.componentKey++
    },
    openNewTab() {
      // 세금계산서 미리보기
      // console.log('파라미터값', this.editingData.mtsid, this.editingData.supRegnum.replace(/\D/g, ''))
      if (this.editingData.mtsid) {
        const baseUrl = 'https://edocu.uplus.co.kr/w20/main.InvoiceView.do' // 기본 URL
        const params = {
          svc_mng_no: this.editingData.mtsid,
          corp_id: this.editingData.supRegnum.replace(/\D/g, ''),
          remoteid: 'CKECASAFETY00',
        }

        // // URLSearchParams를 사용해 파라미터 문자열 생성
        const queryString = new URLSearchParams(params).toString()
        const urlWithParams = `${baseUrl}?${queryString}`

        // 새 탭 열기
        const newTab = window.open(urlWithParams, '_blank')
        if (!newTab) {
          alert('팝업 차단이 활성화되어 있습니다. 팝업 차단을 해제해주세요.')
        }
      } else {
        let errorMsg = ''
        errorMsg = '전자세금계산서 전달이 완료되지 않은 문서입니다.<br> 잠시 후 시도해주세요.'

        if (errorMsg !== '') {
          this.vToastify(this.$t(errorMsg), 'info')
          return
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.sub {
  width: 80px;
  text-align: center !important;
}
.tableTitle {
  width: 100px;
  text-align: center !important;
}
.item-table {
  .v-data-table__wrapper {
    overflow-x: auto;
    width: 100%;
  }
  .tableTitle {
    min-width: 70px;
  }
}
</style>
